type EdgeWithCorpAccount = {
  node?: {
    corpAccount?: {
      uuid?: string;
    } | null;
  } | null;
};

export const filterByCorpAccount = <T extends EdgeWithCorpAccount>(
  edges: T[] | undefined | null,
  accountUuid?: string | null,
): T[] | undefined | null => {
  if (!edges) return edges;

  return accountUuid ? edges.filter(edge => edge.node?.corpAccount?.uuid === accountUuid) : edges;
};
